import * as React from "react";
import { Card, Text } from "../../components";
import type { BookingDetailViewModel } from "./viewModel";
import { OrderStatusChip } from "../ManageBookings/orderStatusChip";
import { BookingDetailSkeleton } from "./BookingDetailSkeleton";
import { AdditionalChargesCard } from "./AdditionalChargesCard";

export function View({ t, ...props }: BookingDetailViewModel) {
  if (props.loading && !props.order) {
    return <BookingDetailSkeleton />;
  }

  if (!props.order) {
    return (
      <div className="flex min-h-[300px] items-center justify-center">
        <Text className="text-center">
          {t("manageBookings.detail.notFound")}
        </Text>
      </div>
    );
  }

  return (
    <div className="mt-[16px]">
      <div className="mb-[16px] flex flex-wrap items-center gap-[8px]">
        <Text level={2} as="span">
          {t("general.booking")}: {props.order.code}
        </Text>
        <OrderStatusChip status={props.order.orderStatus} size="md" />
      </div>

      <div className="grid grid-cols-1 gap-[24px] lg:grid-cols-2">
        {!!props.charges?.additionalChargeRequests.length && (
          <AdditionalChargesCard
            charges={props.charges}
            submitApproval={props.submitApproval}
          />
        )}
        <div className="space-y-[24px]">
          {props.infoCards.map((card, idx) => (
            <Card key={idx} type="advance" {...card} />
          ))}
        </div>
      </div>
    </div>
  );
}
